// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure--figure--2Ltks","background":"Figure--background--jAmsC"};